import { render, staticRenderFns } from "./YieldDetails.vue?vue&type=template&id=33d896b0&scoped=true&lang=html&"
import script from "./YieldDetails.vue?vue&type=script&lang=js&"
export * from "./YieldDetails.vue?vue&type=script&lang=js&"
import style0 from "./YieldDetails.vue?vue&type=style&index=0&id=33d896b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d896b0",
  null
  
)

export default component.exports